import React from 'react';
import './LoadingSpinner.css'; // Ensure this is where your spinner styles are

const LoadingSpinner = () => {
    return <div className="spinner"></div>;
};

export default LoadingSpinner;
